import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { AppContext } from "../../../Context/AppContext";

import LogsList from "../../../Components/Admin/Logs/LogsList";

function UserLogsIndex(props) {
  const navigate = useNavigate();
  const appData = useContext(AppContext);
  const [loaded, setLoaded] = useState(false);

  // Mirrors the backend gate on POST /user/logs/list — @check_rbac("GMSSettings", "read").
  // Without this the page rendered for anyone who could reach the admin area and only the API
  // would refuse, so the table appeared broken rather than forbidden. Same pattern as
  // Components/Admin/Settings/SettingsView.jsx.
  useEffect(() => {
    if (!appData.pm.checkPermission("gmssettings_read")) {
      navigate("/workspace/module/permission/denied");
    } else {
      setLoaded(true);
    }
  }, []); // eslint-disable-line

  if (!loaded) return null;

  return (
    <React.Fragment>
      <div className="container-fluid" data-testid="admin-logs-page">
        <h2>Logs</h2>
        <hr />
        <div className="row">
          <LogsList />
        </div>
      </div>
    </React.Fragment>
  );
}

export default UserLogsIndex;
